import type { LocalePack } from "./types";

const perks = [
  { title: "ללא דמי פיקדון", text: "שוכרים רכב ללא צורך בכרטיס אשראי או בפיקדון ביטחון כלשהו." },
  { title: "ביטוח מקיף כלול", text: "כל רכב מגיע עם ביטוח RCA+CASCO, ויניאטה (אגרת כביש) וקילומטראז' ללא הגבלה." },
  { title: "איסוף חינם", text: "איסוף ללא עלות במשרד ברחוב Regina Elisabeta 33 בבוקרשט או בנמל התעופה אוטופני." },
  { title: "זמינות 24/7", text: "מסירת רכב בכל שעה ביממה, כולל תיאום מהיר בוואטסאפ בטלפון 40738792499+." },
];

const airportPerks = [
  { title: "איסוף בנמל התעופה", text: "צוות carentals.ro ממתין לכם בטרמינל עם הרכב המוזמן מראש, ללא המתנה מיותרת." },
  { title: "מחירים החל מ-35 יורו ליום", text: "מגוון של 28 רכבים במחירים תחרותיים, בתשלום ביורו או בלירה רומנית." },
  { title: "ללא כרטיס אשראי", text: "ניתן לשלם במזומן (יורו או לירה), בכרטיס דביט או בהעברה בנקאית - ללא פיקדון." },
  { title: "משלוח לכל כתובת", text: "משלוח לכל כתובת אחרת בבוקרשט תמורת 20 יורו בלבד, בתיאום מראש." },
];

export const he: LocalePack = {
  code: "he",
  htmlLang: "he",
  dir: "rtl",
  ui: {
    label: "עברית",
    nav: {
      country: "רומניה",
      airports: "נמלי תעופה",
      cities: "ערים",
      guides: "מדריכי טיולים",
    },
    bookCta: "הזמינו רכב עכשיו",
    fleetCta: "צפו בצי הרכבים",
    whatsappCta: "כתבו לנו בוואטסאפ",
    fleetTitle: "צי הרכבים שלנו",
    fleetSubtitle: "28 רכבים במגוון קטגוריות, מוכנים לאיסוף מיידי",
    faqTitle: "שאלות נפוצות",
    mapTitle: "המיקום שלנו",
    relatedTitle: "עמודים קשורים",
    priceNote: "המחירים החל מ-35 יורו ליום, כולל ביטוח וקילומטראז' ללא הגבלה",
    breadcrumbHome: "ראשי",
  },
  pages: {
    country: {
      slug: "",
      title: "השכרת רכב ברומניה | carentals.ro - מחירים משתלמים",
      description: "השכרת רכב ברומניה עם carentals.ro: ללא פיקדון, ביטוח מלא, איסוף חינם בבוקרשט ובאוטופני. מחירים החל מ-35 יורו ליום.",
      eyebrow: "השכרת רכב ברחבי רומניה",
      h1: "השכרת רכב ברומניה - פשוט, בטוח ובלי פיקדון",
      intro: "carentals.ro היא חברת השכרת רכב מקומית מבוקרשט, המציעה 28 רכבים במחירים הוגנים לכל רחבי רומניה. אין צורך בכרטיס אשראי או בפיקדון ביטחון, וכל הזמנה כוללת ביטוח מקיף וקילומטראז' ללא הגבלה. תיאום מהיר מתבצע ישירות דרך וואטסאפ.",
      perks,
      sections: [
        {
          h2: "למה לשכור רכב דרך carentals.ro",
          body: [
            "אנחנו חברה רומנית מקומית עם משרד בלב בוקרשט, המכירה היטב את הכבישים והצרכים של נוסעים ישראלים. כל רכב עובר בדיקה קפדנית לפני מסירה, וניתן לתאם איסוף בכל שעה, כולל לילה.",
            "בניגוד לחברות רבות, איננו דורשים כרטיס אשראי או פיקדון - ניתן לשלם במזומן, בכרטיס דביט או בהעברה בנקאית, ביורו או בלירה רומנית.",
          ],
        },
        {
          h2: "מה כלול במחיר ההשכרה",
          body: [
            "כל השכרה כוללת ביטוח RCA+CASCO מקיף, ויניאטה (אגרת כביש) לנסיעה חופשית בכבישים הבין-עירוניים, וקילומטראז' ללא הגבלה - כך שתוכלו לתכנן מסלול חופשי ברחבי המדינה.",
            "המחירים מתחילים מ-35 יורו ליום בהתאם לדגם ולעונה, ואין עמלות נסתרות. צוות התמיכה שלנו זמין בוואטסאפ למענה מהיר על כל שאלה במהלך הנסיעה.",
          ],
        },
        {
          h2: "איסוף ומסירה ברחבי רומניה",
          body: [
            "האיסוף חינם במשרדנו ברחוב Regina Elisabeta 33 בבוקרשט, וכן בנמל התעופה הנרי קואנדה (אוטופני). משלוח לכתובת אחרת בבוקרשט עולה 20 יורו בלבד.",
            "לנוסעים המגיעים לנמלי תעופה אחרים בקלוז', יאשי, טימישוארה או סיביו, ניתן לתאם משלוח בין-עירוני או השכרה חד-כיוונית בהתאמה אישית - פנו אלינו בוואטסאפ לקבלת הצעת מחיר.",
          ],
        },
      ],
      faqs: [
        { q: "האם צריך כרטיס אשראי כדי לשכור רכב?", a: "לא. אצלנו ניתן לשכור רכב ללא כרטיס אשראי וללא פיקדון ביטחון, בתשלום במזומן, בכרטיס דביט או בהעברה בנקאית." },
        { q: "האם הביטוח כלול במחיר?", a: "כן, כל רכב מבוטח בביטוח RCA+CASCO מקיף, כולל ויניאטה וקילומטראז' ללא הגבלה, ללא עלות נוספת." },
        { q: "היכן ניתן לאסוף את הרכב?", a: "האיסוף חינם במשרדנו בבוקרשט או בנמל התעופה אוטופני. משלוח לכתובות אחרות בבוקרשט עולה 20 יורו." },
        { q: "איך יוצרים קשר להזמנה?", a: "פשוט שלחו הודעה בוואטסאפ למספר 40738792499+ ונחזור אליכם מיד עם כל הפרטים והמחיר." },
      ],
      keywords: "השכרת רכב ברומניה, השכרת רכב בוקרשט, שכירת רכב רומניה, carentals.ro",
    },
    "airport-otopeni": {
      slug: "haskarat-rehev-shdeh-teufa-otopeni",
      title: "השכרת רכב בנמל תעופה אוטופני OTP | carentals.ro",
      description: "השכרת רכב בנמל התעופה הנרי קואנדה אוטופני (OTP) - איסוף חינם, ללא פיקדון, ביטוח מלא ומחירים החל מ-35 יורו ליום.",
      eyebrow: "השכרת רכב בנמל תעופה",
      h1: "השכרת רכב בנמל תעופה אוטופני (OTP), בוקרשט",
      intro: "נחתתם בנמל התעופה הנרי קואנדה באוטופני? צוות carentals.ro ממתין לכם עם הרכב המוזמן, ללא עלות איסוף. כל רכב כולל ביטוח מלא, ויניאטה וקילומטראז' ללא הגבלה, במחירים החל מ-35 יורו ליום.",
      perks: airportPerks,
      sections: [
        {
          h2: "איסוף רכב מיד אחרי הנחיתה",
          body: [
            "מיד לאחר הנחיתה בנמל התעופה אוטופני, נציג מטעמנו יתאם עמכם מקום מפגש נוח, ותוכלו לקבל את הרכב תוך דקות ספורות ללא המתנה בתורים ארוכים.",
            "השירות פעיל 24/7, כך שגם טיסות לילה או השכמה מוקדמת אינן בעיה - פשוט עדכנו אותנו מראש דרך וואטסאפ בפרטי הטיסה.",
          ],
        },
        {
          h2: "מחירים ותנאי תשלום",
          body: [
            "המחירים בנמל התעופה זהים למחירים במשרד המרכזי בבוקרשט, החל מ-35 יורו ליום, ללא עמלת שדה תעופה נסתרת. אפשר לשלם ביורו או בלירה רומנית.",
            "אין צורך בכרטיס אשראי או בפיקדון - התשלום מתבצע במזומן, בכרטיס דביט או בהעברה בנקאית, בהתאם לנוחיותכם.",
          ],
        },
        {
          h2: "המשך הדרך מנמל התעופה",
          body: [
            "מנמל התעופה אוטופני ניתן להגיע במהירות למרכז בוקרשט, ומשם לצאת למסלולי טיול ברחבי רומניה כמו טרנספגרשן וטרנסילבניה.",
            "אם אתם מתכננים המשך נסיעה לנמל תעופה אחר או מסירת הרכב בעיר אחרת, ניתן לתאם השכרה חד-כיוונית מראש דרך וואטסאפ.",
          ],
        },
      ],
      faqs: [
        { q: "איפה בדיוק מתבצע האיסוף בנמל התעופה?", a: "הנציג שלנו יתאם עמכם נקודת מפגש מדויקת בטרמינל היציאות, בהתאם לפרטי הטיסה שתשלחו לנו מראש." },
        { q: "האם יש עלות נוספת לאיסוף בנמל התעופה?", a: "לא, האיסוף בנמל התעופה אוטופני חינם לחלוטין, בדיוק כמו במשרד בבוקרשט." },
        { q: "מה קורה אם הטיסה מתעכבת?", a: "אנחנו עוקבים אחר סטטוס הטיסה ומתאימים את שעת המפגש בהתאם, ללא עלות נוספת." },
        { q: "האם אפשר להחזיר את הרכב בנמל התעופה גם בסוף הנסיעה?", a: "כן, ניתן לתאם החזרה בנמל התעופה אוטופני בתום ההשכרה, בתיאום מראש." },
      ],
      keywords: "השכרת רכב נמל תעופה אוטופני, השכרת רכב OTP, השכרת רכב בוקרשט שדה תעופה",
    },
    "airport-cluj": {
      slug: "haskarat-rehev-shdeh-teufa-cluj",
      title: "השכרת רכב בנמל תעופה קלוז' (CLJ) | carentals.ro",
      description: "השכרת רכב בנמל התעופה קלוז'-נאפוקה (CLJ) עם משלוח מבוקרשט בתיאום מראש. ביטוח מלא, ללא פיקדון, מחירים משתלמים.",
      eyebrow: "השכרת רכב בטרנסילבניה",
      h1: "השכרת רכב בנמל תעופה קלוז' (CLJ)",
      intro: "מגיעים לנמל התעופה קלוז'-נאפוקה? carentals.ro מספקת שירות משלוח רכב מבוקרשט לכל רחבי טרנסילבניה, כולל קלוז', בתיאום אישי מראש. כל רכב מגיע עם ביטוח מלא, ויניאטה וקילומטראז' ללא הגבלה.",
      perks: airportPerks,
      sections: [
        {
          h2: "משלוח רכב לקלוז' מבוקרשט",
          body: [
            "מכיוון שהמשרד הראשי שלנו ממוקם בבוקרשט, השכרה בנמל התעופה בקלוז' מתבצעת באמצעות משלוח בין-עירוני, המתואם מראש בהתאם לתאריך ולשעת הנחיתה שלכם.",
            "נשמח לספק הצעת מחיר מדויקת למשלוח לקלוז' דרך וואטסאפ - כתבו לנו את פרטי הטיסה והתאריכים ונחזור עם הצעה הוגנת וברורה.",
          ],
        },
        {
          h2: "יתרונות השכרת רכב אצלנו",
          body: [
            "גם בהשכרה מרוחקת כמו קלוז', תיהנו מאותם תנאים כמו בבוקרשט: ללא פיקדון, ללא צורך בכרטיס אשראי, וביטוח RCA+CASCO מלא הכלול במחיר.",
            "המחירים מתחילים מ-35 יורו ליום, וניתן לשלם ביורו או בלירה רומנית, במזומן, בדביט או בהעברה בנקאית.",
          ],
        },
        {
          h2: "טיולים מקלוז' לכל טרנסילבניה",
          body: [
            "קלוז'-נאפוקה היא נקודת מוצא מצוינת לטיולי טרנסילבניה, כולל ביקור בטירות, בכפרים סקסוניים ובנופי ההרים הקרפטים.",
            "עם רכב שכור באפשרותכם לתכנן מסלול גמיש הכולל את ברשוב, סיגישוארה ועוד, ולהחזיר את הרכב בבוקרשט או בעיר אחרת בהתאם לתיאום.",
          ],
        },
      ],
      faqs: [
        { q: "האם ניתן לשכור רכב ישירות בנמל התעופה קלוז'?", a: "השירות שלנו מבוסס על משלוח רכב מבוקרשט לקלוז' בתיאום מראש, ולא על נקודת השכרה קבועה בשדה." },
        { q: "כמה עולה המשלוח לקלוז'?", a: "העלות תלויה במרחק ובתאריך, ונשלח הצעת מחיר מדויקת לאחר פנייה בוואטסאפ." },
        { q: "האם אפשר להחזיר את הרכב בעיר אחרת?", a: "כן, ניתן לתאם השכרה חד-כיוונית והחזרה בעיר אחרת, בהתאם לזמינות ולתיאום מראש." },
        { q: "האם הביטוח תקף גם מחוץ לבוקרשט?", a: "בהחלט, ביטוח RCA+CASCO תקף בכל רחבי רומניה, כולל אזור קלוז' וטרנסילבניה." },
      ],
      keywords: "השכרת רכב קלוז, השכרת רכב נמל תעופה קלוז, השכרת רכב טרנסילבניה",
    },
    "airport-iasi": {
      slug: "haskarat-rehev-shdeh-teufa-iasi",
      title: "השכרת רכב בנמל תעופה יאשי (IAS) | carentals.ro",
      description: "השכרת רכב בנמל התעופה יאשי עם משלוח מבוקרשט בתיאום מראש. ביטוח מלא, ללא פיקדון, שירות אישי בעברית.",
      eyebrow: "השכרת רכב במולדובה הרומנית",
      h1: "השכרת רכב בנמל תעופה יאשי (IAS)",
      intro: "יאשי, עיר האוניברסיטאות שבמזרח רומניה, נגישה גם היא באמצעות משלוח רכב מתואם מבוקרשט. carentals.ro דואגת לביטוח מלא, ויניאטה וקילומטראז' ללא הגבלה בכל השכרה.",
      perks: airportPerks,
      sections: [
        {
          h2: "משלוח רכב עד יאשי",
          body: [
            "בשל המרחק מבוקרשט, השכרת רכב ביאשי מתבצעת באמצעות משלוח בין-עירוני מתואם. פנו אלינו בוואטסאפ עם תאריכי הטיסה ונדאג להצעת מחיר מדויקת.",
            "אנו ממליצים לתאם את המשלוח לפחות מספר ימים מראש, כדי להבטיח זמינות רכב מתאים מבין 28 הרכבים בצי שלנו.",
          ],
        },
        {
          h2: "תנאי השכרה זהים בכל רחבי רומניה",
          body: [
            "גם בהשכרה ביאשי, לא נדרש כרטיס אשראי או פיקדון - התשלום גמיש וכולל מזומן, כרטיס דביט או העברה בנקאית, ביורו או בלירה.",
            "המחיר היומי החל מ-35 יורו כולל ביטוח RCA+CASCO, ויניאטה וקילומטראז' ללא הגבלה, בדיוק כמו בבוקרשט.",
          ],
        },
        {
          h2: "סביבת יאשי ואזור מולדובה",
          body: [
            "מיאשי אפשר לצאת בקלות לטיולים באזור מולדובה הרומנית, כולל מנזרים היסטוריים ונופי כפר ציוריים.",
            "רכב פרטי מאפשר גמישות מלאה בתכנון המסלול, במיוחד באזורים בהם התחבורה הציבורית מוגבלת יותר.",
          ],
        },
      ],
      faqs: [
        { q: "האם יש נקודת השכרה קבועה בנמל התעופה יאשי?", a: "השירות מבוסס על משלוח רכב מתואם מבוקרשט, ולא על עמדה קבועה בשדה התעופה." },
        { q: "כמה זמן מראש כדאי לתאם משלוח ליאשי?", a: "מומלץ לתאם לפחות שלושה עד חמישה ימים מראש כדי להבטיח זמינות רכב." },
        { q: "האם המחיר כולל את עלות המשלוח?", a: "עלות המשלוח נספרת בנפרד ותימסר לכם מראש בהצעת מחיר שקופה וברורה." },
        { q: "האם ניתן לקבל את הרכב גם בשעות לילה?", a: "כן, השירות שלנו זמין 24/7 בתיאום מראש דרך וואטסאפ." },
      ],
      keywords: "השכרת רכב יאשי, השכרת רכב נמל תעופה יאשי, שכירת רכב מולדובה רומנית",
    },
    "airport-timisoara": {
      slug: "haskarat-rehev-shdeh-teufa-timisoara",
      title: "השכרת רכב בנמל תעופה טימישוארה (TSR) | carentals.ro",
      description: "השכרת רכב בנמל התעופה טימישוארה עם משלוח מבוקרשט. ביטוח מלא, ללא פיקדון, מחירים החל מ-35 יורו ליום.",
      eyebrow: "השכרת רכב במערב רומניה",
      h1: "השכרת רכב בנמל תעופה טימישוארה (TSR)",
      intro: "טימישוארה, פנינת מערב רומניה, נגישה באמצעות שירות משלוח רכב מבוקרשט. כל רכב כולל ביטוח RCA+CASCO, ויניאטה וקילומטראז' ללא הגבלה - ללא פיקדון וללא כרטיס אשראי.",
      perks: airportPerks,
      sections: [
        {
          h2: "השכרת רכב עם משלוח לטימישוארה",
          body: [
            "בשל המרחק הגדול מבוקרשט, אנו מציעים משלוח רכב מתואם לטימישוארה, בהתאמה אישית לתאריך ולשעת ההגעה שלכם.",
            "צרו קשר בוואטסאפ מספר ימים מראש כדי לתאם את פרטי המשלוח ולקבל הצעת מחיר מדויקת וברורה.",
          ],
        },
        {
          h2: "אותם תנאים נוחים בכל מקום",
          body: [
            "בדיוק כמו בבוקרשט, גם בטימישוארה תיהנו מתשלום גמיש - מזומן, דביט או העברה בנקאית, ביורו או בלירה רומנית, ללא צורך בכרטיס אשראי.",
            "המחיר היומי החל מ-35 יורו כולל ביטוח מקיף וקילומטראז' ללא הגבלה, כך שתוכלו לתכנן את הטיול בראש שקט.",
          ],
        },
        {
          h2: "טיולים ממערב רומניה",
          body: [
            "טימישוארה משמשת נקודת יציאה נוחה לטיולים בהרי בנאט ולערים ההיסטוריות של מערב רומניה.",
            "עם רכב שכור ניתן לשלב ביקור בטימישוארה עם המשך נסיעה לטרנסילבניה, תוך תיאום החזרת הרכב במיקום הנוח ביותר עבורכם.",
          ],
        },
      ],
      faqs: [
        { q: "כיצד מתבצעת ההשכרה בטימישוארה?", a: "באמצעות משלוח רכב מתואם מבוקרשט, המתואם מראש בהתאם לתאריכי הנסיעה שלכם." },
        { q: "האם המחיר משתנה לעומת בוקרשט?", a: "מחיר ההשכרה היומי זהה, בתוספת עלות משלוח שתימסר בהצעת מחיר מראש." },
        { q: "האם ניתן להחזיר את הרכב בעיר אחרת?", a: "כן, ניתן לתאם השכרה חד-כיוונית ומסירה בעיר אחרת בהתאם לתיאום מראש." },
        { q: "מה כלול בביטוח?", a: "ביטוח RCA+CASCO מקיף, ויניאטה וקילומטראז' ללא הגבלה, ללא עלות נוספת." },
      ],
      keywords: "השכרת רכב טימישוארה, השכרת רכב נמל תעופה טימישוארה, שכירת רכב מערב רומניה",
    },
    "airport-sibiu": {
      slug: "haskarat-rehev-shdeh-teufa-sibiu",
      title: "השכרת רכב בנמל תעופה סיביו (SBZ) | carentals.ro",
      description: "השכרת רכב בנמל התעופה סיביו עם משלוח מבוקרשט בתיאום מראש. ביטוח מלא, ללא פיקדון, שירות מהיר בוואטסאפ.",
      eyebrow: "השכרת רכב בלב טרנסילבניה",
      h1: "השכרת רכב בנמל תעופה סיביו (SBZ)",
      intro: "סיביו, אחת הערים היפות בטרנסילבניה, נגישה גם היא באמצעות משלוח רכב מתואם מבוקרשט. כל השכרה כוללת ביטוח מלא, ויניאטה וקילומטראז' ללא הגבלה.",
      perks: airportPerks,
      sections: [
        {
          h2: "משלוח רכב לסיביו",
          body: [
            "השכרת רכב בנמל התעופה סיביו מתבצעת באמצעות משלוח בין-עירוני מבוקרשט, המתואם מראש לפי תאריך ושעת הנחיתה.",
            "מומלץ לפנות אלינו בוואטסאפ מוקדם ככל האפשר כדי להבטיח את הדגם המבוקש מתוך 28 הרכבים בצי שלנו.",
          ],
        },
        {
          h2: "תנאים זהים ללא הפתעות",
          body: [
            "גם בסיביו לא תידרשו לכרטיס אשראי או לפיקדון - התשלום גמיש במזומן, בדביט או בהעברה בנקאית, ביורו או בלירה.",
            "המחיר היומי החל מ-35 יורו כולל ביטוח RCA+CASCO מלא, ויניאטה וקילומטראז' ללא הגבלה.",
          ],
        },
        {
          h2: "סיביו כנקודת מוצא לטיולים",
          body: [
            "מסיביו קרוב מאוד להר טרנספגרשן, לכפרים הסקסוניים ולעיר סיגישוארה ההיסטורית - יעדים מושלמים לטיול ברכב שכור.",
            "ניתן לשלב טיסה לסיביו עם המשך נסיעה ברחבי טרנסילבניה, ולתאם החזרת הרכב בבוקרשט בסיום הטיול.",
          ],
        },
      ],
      faqs: [
        { q: "האם יש נקודת איסוף רכב קבועה בסיביו?", a: "השירות מתבצע באמצעות משלוח מתואם מבוקרשט ולא מנקודה קבועה בשדה התעופה." },
        { q: "כמה זמן לוקח המשלוח לסיביו?", a: "משך הנסיעה כשלוש עד ארבע שעות מבוקרשט, ולכן חשוב לתאם מראש." },
        { q: "האם אפשר לשלם בלירה רומנית?", a: "כן, ניתן לשלם ביורו או בלירה רומנית, במזומן, בדביט או בהעברה בנקאית." },
        { q: "האם הביטוח כולל כיסוי בהרים?", a: "כן, הביטוח תקף בכל רחבי רומניה כולל אזורים הרריים כמו טרנספגרשן." },
      ],
      keywords: "השכרת רכב סיביו, השכרת רכב נמל תעופה סיביו, שכירת רכב טרנסילבניה",
    },
    "city-bucharest": {
      slug: "haskarat-rehev-bucharest",
      title: "השכרת רכב בבוקרשט | carentals.ro - ללא פיקדון",
      description: "השכרת רכב בבוקרשט עם איסוף חינם במשרד או בנמל התעופה אוטופני. ביטוח מלא, ללא פיקדון, מחירים מ-35 יורו ליום.",
      eyebrow: "השכרת רכב בבירת רומניה",
      h1: "השכרת רכב בבוקרשט",
      intro: "בוקרשט היא הבסיס של carentals.ro, עם משרד מרכזי ברחוב Regina Elisabeta 33 ואיסוף חינם גם בנמל התעופה אוטופני. 28 רכבים זמינים במגוון קטגוריות, במחירים החל מ-35 יורו ליום.",
      perks,
      sections: [
        {
          h2: "השכרת רכב במשרד המרכזי בבוקרשט",
          body: [
            "המשרד שלנו ממוקם ברחוב Regina Elisabeta 33, בלב בוקרשט, ומאפשר איסוף נוח ומהיר ללא עלות נוספת.",
            "הצוות המקומי שלנו ידריך אתכם לגבי חניה, כללי נהיגה בעיר ומסלולים מומלצים ליציאה מהעיר.",
          ],
        },
        {
          h2: "נהיגה בבוקרשט - מה כדאי לדעת",
          body: [
            "התנועה במרכז העיר עלולה להיות עמוסה בשעות השיא, ולכן מומלץ לתכנן יציאה מהעיר מחוץ לשעות אלו.",
            "כל רכב מגיע עם ויניאטה תקפה, כך שאין צורך לדאוג לרכישת אגרת כביש בעת יציאה לכביש הבין-עירוני.",
          ],
        },
        {
          h2: "יעדים קרובים לבוקרשט",
          body: [
            "מבוקרשט ניתן להגיע בקלות לחוף הים השחור, לברשוב ולהרי הקרפטים, כולל מסלול הטרנספגרשן המפורסם.",
            "השכרת רכב מקומית מאפשרת חופש תנועה מלא, ללא תלות בתחבורה ציבורית או תיאום טיולים מאורגנים.",
          ],
        },
      ],
      faqs: [
        { q: "היכן ממוקם המשרד בבוקרשט?", a: "המשרד שלנו נמצא ברחוב Regina Elisabeta 33, במרכז בוקרשט, עם איסוף חינם." },
        { q: "האם ניתן לקבל את הרכב גם בנמל התעופה?", a: "כן, האיסוף חינם גם בנמל התעופה הנרי קואנדה באוטופני." },
        { q: "כמה עולה משלוח לכתובת אחרת בעיר?", a: "משלוח לכל כתובת אחרת בבוקרשט עולה 20 יורו בלבד." },
        { q: "האם צריך כרטיס אשראי להשכרה בבוקרשט?", a: "לא, ניתן לשכור רכב ללא כרטיס אשראי וללא פיקדון." },
      ],
      keywords: "השכרת רכב בבוקרשט, השכרת רכב ברומניה, שכירת רכב בוקרשט",
    },
    "city-brasov": {
      slug: "haskarat-rehev-brasov",
      title: "השכרת רכב בברשוב | carentals.ro - עם משלוח מבוקרשט",
      description: "השכרת רכב בברשוב עם משלוח מבוקרשט בתיאום מראש. ביטוח מלא, ללא פיקדון, מחירים משתלמים לטיולי טרנסילבניה.",
      eyebrow: "השכרת רכב לטיולי הרים",
      h1: "השכרת רכב בברשוב",
      intro: "ברשוב, שער הכניסה להרי הקרפטים, נגישה באמצעות משלוח רכב מתואם מבוקרשט. carentals.ro מספקת רכב אמין עם ביטוח מלא לכל טיול בטרנסילבניה.",
      perks,
      sections: [
        {
          h2: "משלוח רכב לברשוב",
          body: [
            "ברשוב נמצאת כשעתיים וחצי נסיעה מבוקרשט, ואנו מציעים משלוח רכב מתואם ישירות לעיר או לתחנת הרכבת המקומית.",
            "פנו אלינו בוואטסאפ עם תאריכי הטיול ונדאג לתאם את המשלוח ולספק הצעת מחיר שקופה.",
          ],
        },
        {
          h2: "טיולים מברשוב",
          body: [
            "מברשוב אפשר להגיע בקלות לטירת בראן, לפוינה ברשוב ולמסלול הטרנספגרשן המרהיב.",
            "רכב פרטי מעניק גמישות לתכנן עצירות בדרך בכפרים ציוריים ובנקודות תצפית, ללא לוח זמנים קבוע.",
          ],
        },
        {
          h2: "תנאי השכרה נוחים",
          body: [
            "כמו בכל רחבי רומניה, גם בברשוב אין צורך בפיקדון או בכרטיס אשראי - התשלום גמיש וכולל ביטוח מקיף.",
            "המחיר היומי החל מ-35 יורו כולל ויניאטה וקילומטראז' ללא הגבלה, כך שהטיול בהרים לא כרוך בעלויות נסתרות.",
          ],
        },
      ],
      faqs: [
        { q: "כמה זמן לוקח המשלוח לברשוב?", a: "כשעתיים וחצי עד שלוש שעות נסיעה מבוקרשט, בתיאום מראש." },
        { q: "האם ניתן להחזיר את הרכב בברשוב?", a: "כן, ניתן לתאם השכרה חד-כיוונית והחזרה בברשוב בהתאם לזמינות." },
        { q: "האם הביטוח מכסה נהיגה בהרים?", a: "כן, ביטוח RCA+CASCO תקף לכל רחבי רומניה, כולל אזורים הרריים." },
        { q: "מה מומלץ לראות בדרך מברשוב?", a: "טירת בראן, טירת פלש, ומסלול הטרנספגרשן הם יעדים מומלצים בסביבה." },
      ],
      keywords: "השכרת רכב ברשוב, שכירת רכב טרנסילבניה, השכרת רכב הרי קרפטים",
    },
    "city-cluj": {
      slug: "haskarat-rehev-cluj",
      title: "השכרת רכב בקלוז'-נאפוקה | carentals.ro",
      description: "השכרת רכב בקלוז'-נאפוקה עם משלוח מבוקרשט בתיאום מראש. ביטוח מלא, ללא פיקדון, שירות אישי בעברית.",
      eyebrow: "השכרת רכב בעיר הסטודנטים",
      h1: "השכרת רכב בקלוז'-נאפוקה",
      intro: "קלוז'-נאפוקה, עיר הסטודנטים התוססת של טרנסילבניה, נגישה באמצעות משלוח רכב מתואם מבוקרשט, עם ביטוח מלא וללא פיקדון.",
      perks,
      sections: [
        {
          h2: "השכרת רכב עם משלוח לקלוז'",
          body: [
            "מכיוון שהמשרד הראשי שלנו ממוקם בבוקרשט, השכרה בקלוז' מתבצעת באמצעות משלוח מתואם, בהתאם לתאריכי הביקור שלכם.",
            "אנו ממליצים לתאם מראש דרך וואטסאפ, במיוחד בעונות התיירות העמוסות.",
          ],
        },
        {
          h2: "מה רואים בקלוז' וסביבתה",
          body: [
            "קלוז'-נאפוקה מציעה שילוב של אדריכלות היסטורית, חיי לילה תוססים ומוזיאונים מעניינים, ומשמשת בסיס נוח לטיולים בטרנסילבניה.",
            "עם רכב שכור ניתן לשלב ביקור בעיר עם נסיעה לכפרים סקסוניים סמוכים ולנופי הכפר האותנטיים של האזור.",
          ],
        },
        {
          h2: "תנאי השכרה ותשלום",
          body: [
            "המחיר היומי החל מ-35 יורו כולל ביטוח RCA+CASCO, ויניאטה וקילומטראז' ללא הגבלה, ללא הפתעות.",
            "התשלום גמיש - במזומן, בכרטיס דביט או בהעברה בנקאית, ביורו או בלירה רומנית, ללא צורך בכרטיס אשראי.",
          ],
        },
      ],
      faqs: [
        { q: "האם יש משרד השכרה קבוע בקלוז'?", a: "לא, השירות מבוסס על משלוח רכב מתואם מבוקרשט לקלוז'." },
        { q: "כמה זמן מראש כדאי לתאם?", a: "מומלץ לתאם לפחות שלושה ימים מראש כדי להבטיח זמינות רכב." },
        { q: "האם ניתן לשלב ביקור בקלוז' עם מסלול טרנסילבניה?", a: "בהחלט, קלוז' היא נקודת מוצא מצוינת למסלול טרנסילבניה מלא." },
        { q: "האם המחיר כולל ביטוח מלא?", a: "כן, כל השכרה כוללת ביטוח RCA+CASCO מקיף ללא עלות נוספת." },
      ],
      keywords: "השכרת רכב קלוז, שכירת רכב קלוז נאפוקה, השכרת רכב טרנסילבניה",
    },
    "city-constanta": {
      slug: "haskarat-rehev-constanta",
      title: "השכרת רכב בקונסטנצה | carentals.ro - חוף הים השחור",
      description: "השכרת רכב בקונסטנצה ובחוף הים השחור עם משלוח מבוקרשט. ביטוח מלא, ללא פיקדון, מחירים מ-35 יורו ליום.",
      eyebrow: "השכרת רכב לחוף הים",
      h1: "השכרת רכב בקונסטנצה",
      intro: "קונסטנצה ורצועת חוף הים השחור הם יעד קיץ פופולרי, ונגישים באמצעות משלוח רכב מתואם מבוקרשט. כל השכרה כוללת ביטוח מלא וקילומטראז' ללא הגבלה.",
      perks,
      sections: [
        {
          h2: "משלוח רכב לקונסטנצה",
          body: [
            "המרחק מבוקרשט לקונסטנצה הוא כשעתיים וחצי נסיעה, ואנו מציעים משלוח מתואם ישירות לעיר או לאזורי הנופש הסמוכים.",
            "בעונת הקיץ מומלץ לתאם מראש ככל האפשר, שכן הביקוש לרכבים באזור החוף גבוה במיוחד.",
          ],
        },
        {
          h2: "טיולי חוף הים השחור",
          body: [
            "רכב שכור מאפשר לנוע בקלות בין קונסטנצה, מאמאיה ויתר אזורי הנופש לאורך החוף, ללא תלות באוטובוסים או מוניות.",
            "כמו כן, ניתן לשלב ביקור באתרים היסטוריים ובעיר העתיקה של קונסטנצה, המשלבת השפעות רומיות ועות'מאניות.",
          ],
        },
        {
          h2: "תנאי השכרה נוחים לקיץ",
          body: [
            "המחיר היומי החל מ-35 יורו כולל ביטוח RCA+CASCO, ויניאטה וקילומטראז' ללא הגבלה - אידיאלי לטיולי חוף ארוכים.",
            "אין צורך בכרטיס אשראי או בפיקדון, והתשלום גמיש במזומן, בדביט או בהעברה בנקאית.",
          ],
        },
      ],
      faqs: [
        { q: "כמה זמן לוקח להגיע לקונסטנצה מבוקרשט?", a: "כשעתיים וחצי עד שלוש שעות נסיעה, בהתאם לתנועה." },
        { q: "האם כדאי לתאם מראש בעונת הקיץ?", a: "בהחלט, הביקוש גבוה בקיץ ומומלץ לתאם לפחות שבוע מראש." },
        { q: "האם ניתן להחזיר את הרכב בקונסטנצה?", a: "כן, ניתן לתאם השכרה חד-כיוונית והחזרה בקונסטנצה בהתאם לזמינות." },
        { q: "האם הביטוח מכסה נהיגה באזור החוף?", a: "כן, הביטוח תקף בכל רחבי רומניה כולל אזור החוף כולו." },
      ],
      keywords: "השכרת רכב קונסטנצה, השכרת רכב ים שחור, שכירת רכב מאמאיה",
    },
    cheap: {
      slug: "haskarat-rehev-zola",
      title: "השכרת רכב זולה ברומניה | carentals.ro - מ-35 יורו",
      description: "השכרת רכב זולה ברומניה החל מ-35 יורו ליום, ללא פיקדון וללא כרטיס אשראי. ביטוח מלא וקילומטראז' ללא הגבלה כלולים.",
      eyebrow: "השכרת רכב במחיר משתלם",
      h1: "השכרת רכב זולה ברומניה",
      intro: "מחפשים השכרת רכב זולה ברומניה בלי להתפשר על איכות? carentals.ro מציעה מחירים החל מ-35 יורו ליום, כולל ביטוח מלא, ויניאטה וקילומטראז' ללא הגבלה - ללא עמלות נסתרות.",
      perks,
      sections: [
        {
          h2: "איך אנחנו שומרים על מחירים נמוכים",
          body: [
            "כחברה מקומית ללא תיווך זר, אנו מנהלים ישירות את צי 28 הרכבים שלנו, מה שמאפשר לנו להציע מחירים תחרותיים ללא עמלות סוכנות.",
            "המחיר היומי כולל את כל מה שצריך - ביטוח, ויניאטה וקילומטראז' ללא הגבלה, כך שאין הפתעות בחשבון הסופי.",
          ],
        },
        {
          h2: "חיסכון נוסף בלי פיקדון",
          body: [
            "מכיוון שאיננו דורשים פיקדון או כרטיס אשראי, אין צורך בחסימת כספים בכרטיס האשראי לאורך כל תקופת הנסיעה.",
            "התשלום גמיש - במזומן, בדביט או בהעברה בנקאית, ביורו או בלירה רומנית, בהתאם למה שנוח לכם.",
          ],
        },
        {
          h2: "טיפים להוזלת עלות ההשכרה",
          body: [
            "הזמנה מוקדמת מבטיחה זמינות רחבה יותר ולעיתים מחירים נוחים יותר, במיוחד בעונת השיא בקיץ.",
            "בחירת רכב קטן וחסכוני יכולה להוזיל משמעותית את עלות הדלק והחניה, בעיקר בנסיעות עירוניות בבוקרשט.",
          ],
        },
      ],
      faqs: [
        { q: "מה המחיר הזול ביותר להשכרת רכב?", a: "המחירים מתחילים מ-35 יורו ליום, בהתאם לדגם ולעונה." },
        { q: "האם המחיר הזול כולל ביטוח?", a: "כן, כל מחיר כולל ביטוח RCA+CASCO, ויניאטה וקילומטראז' ללא הגבלה." },
        { q: "האם יש עלויות נסתרות?", a: "לא, אין עמלות נסתרות - המחיר שמוצג הוא המחיר הסופי, למעט תוספת משלוח אם רלוונטית." },
        { q: "איך מקבלים את ההצעה הזולה ביותר?", a: "פנו אלינו בוואטסאפ עם תאריכי הנסיעה ונשמח להתאים לכם את הרכב המשתלם ביותר." },
      ],
      keywords: "השכרת רכב זולה ברומניה, השכרת רכב מחיר משתלם, שכירת רכב זולה בוקרשט",
    },
    automatic: {
      slug: "haskarat-rehev-automati",
      title: "השכרת רכב אוטומטי ברומניה | carentals.ro",
      description: "השכרת רכב עם גיר אוטומטי ברומניה - נוחות מרבית לנהיגה עירונית ובין-עירונית. ביטוח מלא, ללא פיקדון, מחירים משתלמים.",
      eyebrow: "השכרת רכב עם גיר אוטומטי",
      h1: "השכרת רכב אוטומטי ברומניה",
      intro: "רכבים עם גיר אוטומטי מספקים נוחות מרבית בנהיגה בעיר ובכבישים הבין-עירוניים ברומניה. carentals.ro מציעה מגוון דגמים אוטומטיים בצי של 28 רכבים, עם ביטוח מלא וללא פיקדון.",
      perks,
      sections: [
        {
          h2: "למה לבחור ברכב אוטומטי",
          body: [
            "נהיגה עם גיר אוטומטי נוחה במיוחד בפקקי התנועה של בוקרשט ובכבישים ההרריים המפותלים כמו מסלול הטרנספגרשן.",
            "עבור נהגים שאינם רגילים לגיר ידני, רכב אוטומטי מפחית משמעותית את העומס והמתח בנהיגה במדינה זרה.",
          ],
        },
        {
          h2: "זמינות דגמים אוטומטיים",
          body: [
            "בצי שלנו קיימים מספר דגמים עם גיר אוטומטי בקטגוריות שונות, מרכבים קומפקטיים ועד רכבי משפחה מרווחים.",
            "מומלץ לציין מראש בבקשת ההזמנה כי אתם מעוניינים ברכב אוטומטי, כדי שנוכל להבטיח את הזמינות המדויקת.",
          ],
        },
        {
          h2: "תנאי השכרה זהים",
          body: [
            "השכרת רכב אוטומטי כוללת את אותם התנאים כמו כל השכרה אחרת - ביטוח RCA+CASCO, ויניאטה וקילומטראז' ללא הגבלה.",
            "המחיר היומי החל מ-35 יורו, ללא צורך בכרטיס אשראי או בפיקדון, עם אפשרות תשלום גמישה.",
          ],
        },
      ],
      faqs: [
        { q: "האם יש תוספת מחיר לרכב אוטומטי?", a: "המחיר תלוי בדגם הספציפי ולא בסוג הגיר בלבד - נשמח לספק הצעת מחיר מדויקת לפי דרישתכם." },
        { q: "כמה דגמים אוטומטיים יש בצי?", a: "יש לנו מספר דגמים אוטומטיים במגוון קטגוריות - פנו אלינו לבדיקת זמינות עדכנית." },
        { q: "האם רכב אוטומטי מתאים לנהיגה בהרים?", a: "בהחלט, גיר אוטומטי נוח במיוחד בכבישים ההרריים המפותלים ברומניה." },
        { q: "איך מזמינים רכב אוטומטי?", a: "פשוט ציינו זאת בהודעה בוואטסאפ ונדאג להבטיח לכם רכב מתאים." },
      ],
      keywords: "השכרת רכב אוטומטי, השכרת רכב גיר אוטומטי רומניה, שכירת רכב אוטומטי בוקרשט",
    },
    "unlimited-km": {
      slug: "haskarat-rehev-kilometrag-lelo-hagbala",
      title: "השכרת רכב עם קילומטראז' ללא הגבלה | carentals.ro",
      description: "כל השכרת רכב אצלנו כוללת קילומטראז' ללא הגבלה ברומניה, ללא עלות נוספת ובלי דאגות. ביטוח מלא וללא פיקדון.",
      eyebrow: "נסיעה חופשית ללא הגבלת מרחק",
      h1: "השכרת רכב עם קילומטראז' ללא הגבלה",
      intro: "כל רכב שנשכר דרך carentals.ro כולל קילומטראז' ללא הגבלה ברחבי רומניה, ללא תוספת תשלום. כך תוכלו לתכנן מסלול חופשי מבוקרשט ועד לפינות הנידחות ביותר של המדינה.",
      perks,
      sections: [
        {
          h2: "חופש מלא לתכנן את המסלול",
          body: [
            "בניגוד לחברות רבות המגבילות את מספר הקילומטרים היומי, אצלנו אין הגבלה כלל - נהגו כמה שתרצו בלי חשש מחיוב נוסף.",
            "זה מאפשר לתכנן מסלולים ארוכים כמו סיבוב מלא סביב טרנסילבניה, הרי הקרפטים וחוף הים השחור באותה השכרה.",
          ],
        },
        {
          h2: "מתאים לטיולי כביש ארוכים",
          body: [
            "טיולי כביש ברומניה, כמו מסלול הטרנספגרשן או סיור בין הכפרים הסקסוניים, דורשים לעיתים נסיעה של מאות קילומטרים ביום אחד.",
            "עם קילומטראז' ללא הגבלה, אין צורך לחשב מראש כל קילומטר, ואתם חופשיים לסטות מהמסלול המתוכנן בכל רגע.",
          ],
        },
        {
          h2: "מה עוד כלול בהשכרה",
          body: [
            "מלבד קילומטראז' ללא הגבלה, כל השכרה כוללת ביטוח RCA+CASCO מקיף וויניאטה תקפה לכל הכבישים הבין-עירוניים.",
            "המחיר היומי החל מ-35 יורו, ללא צורך בכרטיס אשראי או פיקדון, עם אפשרויות תשלום גמישות.",
          ],
        },
      ],
      faqs: [
        { q: "האם יש הגבלת קילומטרים בהשכרה?", a: "לא, כל השכרה אצלנו כוללת קילומטראז' ללא הגבלה ללא עלות נוספת." },
        { q: "האם זה תקף לכל דגמי הרכב?", a: "כן, קילומטראז' ללא הגבלה כלול בכל ה-28 הרכבים בצי שלנו." },
        { q: "האם אפשר לנסוע מחוץ לרומניה?", a: "ההשכרה מיועדת לנסיעה בתוך רומניה - לנסיעה לחו״ל יש לתאם אישור מראש בוואטסאפ." },
        { q: "האם יש הגבלה על מספר הימים?", a: "לא, ניתן לשכור לתקופה קצרה או ארוכה בהתאם לצורך, עם אותם תנאים." },
      ],
      keywords: "קילומטראז ללא הגבלה, השכרת רכב ללא הגבלת קילומטרים, שכירת רכב רומניה",
    },
    "one-way": {
      slug: "haskarat-rehev-had-kivunit",
      title: "השכרת רכב חד-כיוונית ברומניה | carentals.ro",
      description: "השכרת רכב חד-כיוונית ברומניה - איסוף בעיר אחת והחזרה באחרת, בתיאום מראש. ביטוח מלא, ללא פיקדון.",
      eyebrow: "גמישות מלאה במסלול הנסיעה",
      h1: "השכרת רכב חד-כיוונית ברומניה",
      intro: "מתכננים מסלול שאינו חוזר לנקודת ההתחלה? carentals.ro מאפשרת השכרה חד-כיוונית, עם איסוף בעיר אחת והחזרה באחרת, בתיאום אישי מראש דרך וואטסאפ.",
      perks: [
        { title: "מסלול גמיש", text: "איסוף בבוקרשט או באוטופני והחזרה בעיר אחרת ברומניה, בהתאם לתיאום." },
        { title: "הצעת מחיר אישית", text: "כל בקשה להשכרה חד-כיוונית מקבלת הצעת מחיר מותאמת לפי המרחק והיעד." },
        { title: "ביטוח מלא בכל מקום", text: "הביטוח וכל תנאי ההשכרה תקפים לאורך כל המסלול, ללא קשר לעיר ההחזרה." },
        { title: "תיאום מהיר בוואטסאפ", text: "פנו אלינו מראש עם פרטי המסלול ונחזור עם אישור וזמינות תוך זמן קצר." },
      ],
      sections: [
        {
          h2: "איך עובדת השכרה חד-כיוונית",
          body: [
            "השכרה חד-כיוונית מאפשרת לכם לאסוף את הרכב בבוקרשט או באוטופני, ולהחזיר אותו בעיר אחרת כמו ברשוב, קלוז' או קונסטנצה.",
            "מכיוון שמדובר בשירות מותאם אישית, יש לתאם אותו מראש דרך וואטסאפ ולקבל אישור זמינות והצעת מחיר.",
          ],
        },
        {
          h2: "מתי כדאי לבחור בהשכרה חד-כיוונית",
          body: [
            "אם אתם טסים חזרה מנמל תעופה שונה מזה שבו נחתתם, או מתכננים מסלול טיול ליניארי ברחבי רומניה, זהו הפתרון האידיאלי.",
            "לדוגמה, ניתן לאסוף רכב בבוקרשט, לסייר בטרנסילבניה ובחוף הים השחור, ולהחזיר את הרכב בעיר הקרובה לטיסת החזרה.",
          ],
        },
        {
          h2: "עלויות ותיאום מראש",
          body: [
            "עלות ההשכרה החד-כיוונית תלויה במרחק בין נקודת האיסוף להחזרה, ותימסר מראש בהצעת מחיר שקופה.",
            "מומלץ לתאם את הבקשה לפחות מספר ימים מראש, כדי להבטיח את זמינות הרכב ולתאם את פרטי המסירה וההחזרה.",
          ],
        },
      ],
      faqs: [
        { q: "האם השכרה חד-כיוונית אפשרית לכל היעדים?", a: "רוב היעדים ברומניה ניתנים לתיאום, בכפוף לזמינות ולתיאום מראש." },
        { q: "כמה עולה השכרה חד-כיוונית?", a: "העלות תלויה במרחק בין ערי האיסוף וההחזרה, ותימסר בהצעת מחיר אישית." },
        { q: "כמה זמן מראש צריך לתאם?", a: "מומלץ לתאם לפחות שלושה עד חמישה ימים מראש." },
        { q: "האם הביטוח תקף לאורך כל המסלול?", a: "כן, הביטוח המלא תקף בכל רחבי רומניה, ללא תלות בעיר ההחזרה." },
      ],
      keywords: "השכרת רכב חד כיוונית, השכרת רכב עם החזרה בעיר אחרת, שכירת רכב גמישה רומניה",
    },
    "seven-seater": {
      slug: "haskarat-rehev-shiva-moshavim",
      title: "השכרת רכב 7 מקומות ברומניה | carentals.ro",
      description: "השכרת רכב מיניוואן 7 מקומות ברומניה למשפחות וקבוצות. ביטוח מלא, ללא פיקדון, מחירים משתלמים.",
      eyebrow: "השכרת רכב למשפחות וקבוצות",
      h1: "השכרת רכב 7 מקומות ברומניה",
      intro: "נוסעים כמשפחה גדולה או קבוצת חברים? carentals.ro מציעה רכבי מיניוואן ל-7 נוסעים, עם מקום נוח למטען, ביטוח מלא וקילומטראז' ללא הגבלה.",
      perks: [
        { title: "מקום לכל המשפחה", text: "רכבי מיניוואן מרווחים ל-7 נוסעים ומטען, מושלמים לטיולי משפחה וקבוצה." },
        { title: "נוחות לטיולים ארוכים", text: "מושבים מרווחים ומיזוג אוויר איכותי, מתאימים לנסיעות ארוכות ברחבי רומניה." },
        { title: "ביטוח מקיף כלול", text: "כל רכב 7 מקומות מבוטח בביטוח RCA+CASCO מלא, ללא עלות נוספת." },
        { title: "זמינות מוגבלת - הזמינו מראש", text: "מספר רכבי המיניוואן בצי מוגבל, ומומלץ להזמין מוקדם ככל האפשר." },
      ],
      sections: [
        {
          h2: "מתי כדאי לבחור רכב 7 מקומות",
          body: [
            "משפחות עם ילדים, קבוצות חברים או נוסעים עם ציוד רב ייהנו מהמרחב הנוסף שמציע רכב מיניוואן ל-7 נוסעים.",
            "רכב גדול יותר גם מספק תחושת ביטחון ונוחות בנסיעות ארוכות ברחבי רומניה, כולל מסלולים הרריים כמו הטרנספגרשן.",
          ],
        },
        {
          h2: "זמינות והזמנה מראש",
          body: [
            "מכיוון שמספר רכבי המיניוואן בצי מוגבל ביחס לרכבים הקטנים, מומלץ מאוד להזמין מראש, במיוחד בעונת הקיץ.",
            "פנו אלינו בוואטסאפ עם תאריכי הנסיעה ומספר הנוסעים, ונדאג להבטיח לכם את הרכב המתאים ביותר.",
          ],
        },
        {
          h2: "תנאי ההשכרה",
          body: [
            "גם רכבי 7 המקומות כוללים ביטוח RCA+CASCO מקיף, ויניאטה וקילומטראז' ללא הגבלה, ללא צורך בכרטיס אשראי או פיקדון.",
            "המחיר משתנה מעט בהתאם לדגם, אך תמיד ללא עמלות נסתרות, עם אפשרות תשלום ביורו או בלירה רומנית.",
          ],
        },
      ],
      faqs: [
        { q: "כמה נוסעים ניתן להסיע ברכב 7 מקומות?", a: "עד 7 נוסעים בנוסף למקום למטען, בהתאם לדגם הספציפי." },
        { q: "האם צריך להזמין מראש?", a: "כן, מומלץ מאוד להזמין מראש בשל זמינות מוגבלת של רכבי מיניוואן." },
        { q: "האם הביטוח כלול גם ברכבי 7 מקומות?", a: "כן, כל רכב כולל ביטוח RCA+CASCO מלא, ללא עלות נוספת." },
        { q: "האם ניתן לאסוף רכב כזה בנמל התעופה?", a: "כן, ניתן לתאם איסוף חינם בנמל התעופה אוטופני, בכפוף לזמינות." },
      ],
      keywords: "השכרת רכב 7 מקומות, השכרת מיניוואן ברומניה, שכירת רכב משפחתי בוקרשט",
    },
    "guide-transfagarasan": {
      slug: "madrih-transfagarashan",
      title: "מדריך לנהיגה בטרנספגרשן | carentals.ro",
      description: "מדריך מקיף לנהיגה במסלול הטרנספגרשן המפורסם ברומניה - טיפים, עונות מומלצות והכנה נכונה לטיול.",
      eyebrow: "מדריך טיולי כביש ברומניה",
      h1: "מדריך לנהיגה במסלול הטרנספגרשן",
      intro: "כביש הטרנספגרשן (Transfagarasan) הוא אחד ממסלולי ההרים המרשימים באירופה, המשלב עקומות דרמטיות ונופים עוצרי נשימה. carentals.ro מספקת רכב אמין ומבוטח לטיול הזה, עם קילומטראז' ללא הגבלה.",
      perks,
      sections: [
        {
          h2: "מהו מסלול הטרנספגרשן",
          body: [
            "הכביש נמתח על פני הרי פגרש וקרפטים, ונחשב לאחד הכבישים ההרריים המרשימים בעולם, עם עקומות חדות ותצפיות פנורמיות.",
            "המסלול מחבר את אזור וולצ'ה עם טרנסילבניה, ועובר ליד סכר ואגם ואידה, יעד תיירותי פופולרי בפני עצמו.",
          ],
        },
        {
          h2: "מתי לנסוע ואיך להתכונן",
          body: [
            "הכביש פתוח בדרך כלל בין יוני לאוקטובר בלבד, שכן בחורף הוא מכוסה שלג וסגור לתנועה. מומלץ לבדוק את סטטוס הפתיחה מראש.",
            "רכב עם ביטוח מקיף חיוני למסלול זה, מאחר שהעקומות והשיפועים דורשים נהיגה זהירה ורכב אמין.",
          ],
        },
        {
          h2: "טיפים לנהיגה בטוחה",
          body: [
            "יש לנהוג לאט ובזהירה, לעצור רק בנקודות התצפית המיועדות, ולהימנע מעצירה פתאומית בעקומות החדות.",
            "מומלץ לצאת לדרך בשעות הבוקר המוקדמות כדי להימנע מעומס תיירים ולתפוס את האור הטוב ביותר לתמונות.",
          ],
        },
      ],
      faqs: [
        { q: "מתי הכביש פתוח לנסיעה?", a: "בדרך כלל בין יוני לאוקטובר, בהתאם לתנאי מזג האוויר והשלג." },
        { q: "האם צריך רכב מיוחד לנסיעה?", a: "רכב רגיל עם ביטוח מקיף מספיק, אך מומלץ רכב עם כוח מנוע סביר לעקומות התלולות." },
        { q: "כמה זמן אורכת הנסיעה במסלול?", a: "בין שעה לשעתיים לחלק ההררי בלבד, בהתאם לעצירות בדרך." },
        { q: "האם הביטוח שלנו מכסה נהיגה בטרנספגרשן?", a: "כן, ביטוח RCA+CASCO תקף לכל רחבי רומניה כולל מסלול זה." },
      ],
      keywords: "טרנספגרשן, נהיגה בטרנספגרשן, מדריך טיול ברומניה, השכרת רכב לטרנספגרשן",
    },
    "guide-transylvania": {
      slug: "madrih-transylvania",
      title: "מדריך טיול ברכב לטרנסילבניה | carentals.ro",
      description: "מדריך מקיף לטיול רכב בטרנסילבניה - טירות, כפרים סקסוניים ונופים היסטוריים. עם רכב שכור מ-carentals.ro.",
      eyebrow: "מדריך טיולי כביש ברומניה",
      h1: "מדריך לטיול רכב בטרנסילבניה",
      intro: "טרנסילבניה מציעה שילוב ייחודי של טירות עתיקות, כפרים סקסוניים וטבע עוצר נשימה. עם רכב שכור מ-carentals.ro, ניתן לתכנן מסלול גמיש הכולל את כל היעדים החשובים באזור.",
      perks,
      sections: [
        {
          h2: "יעדים מרכזיים בטרנסילבניה",
          body: [
            "סיגישוארה, ברשוב וסיביו הן שלוש הערים ההיסטוריות המרכזיות, כל אחת עם עיר עתיקה שמורה וארכיטקטורה סקסונית ייחודית.",
            "טירת בראן וטירת פלש הן אטרקציות מרכזיות נוספות, ומומלץ לשלב אותן במסלול לצד ביקור בכפרים המבוצרים של האזור.",
          ],
        },
        {
          h2: "תכנון מסלול הרכב",
          body: [
            "מומלץ לתכנן מסלול של 4-7 ימים המחבר את הערים הראשיות עם עצירות בכפרים קטנים לאורך הדרך.",
            "עם קילומטראז' ללא הגבלה בכל השכרה, ניתן לסטות מהמסלול המתוכנן ולגלות מקומות נוספים ללא דאגה מעלויות נוספות.",
          ],
        },
        {
          h2: "טיפים מעשיים לנוסעים",
          body: [
            "רוב הכבישים בטרנסילבניה במצב טוב, אך מומלץ להיזהר מכבישי כפר צרים יותר ומעדרי בעלי חיים החוצים את הדרך.",
            "ויניאטה כלולה בכל השכרה, כך שאין צורך לדאוג לרכישת אגרת כביש בעת נסיעה בין הערים השונות.",
          ],
        },
      ],
      faqs: [
        { q: "כמה ימים כדאי להקדיש לטיול בטרנסילבניה?", a: "מומלץ בין 4 ל-7 ימים כדי לכסות את היעדים המרכזיים בנוחות." },
        { q: "האם הכבישים מתאימים לנהיגה עצמאית?", a: "כן, רוב הכבישים המרכזיים במצב טוב ומתאימים לנהיגה עצמאית." },
        { q: "האם יש עלות נוספת לוויניאטה?", a: "לא, הוויניאטה כלולה בכל השכרה ללא עלות נוספת." },
        { q: "מאיפה כדאי להתחיל את המסלול?", a: "ניתן להתחיל בבוקרשט או להזמין משלוח רכב ישירות לברשוב או סיביו." },
      ],
      keywords: "טיול רכב טרנסילבניה, מדריך טרנסילבניה, השכרת רכב לטרנסילבניה",
    },
    "guide-black-sea": {
      slug: "madrih-hof-hayam-hashahor",
      title: "מדריך טיול לחוף הים השחור | carentals.ro",
      description: "מדריך לטיול רכב לחוף הים השחור ברומניה - קונסטנצה, מאמאיה ועוד. עם רכב שכור מ-carentals.ro.",
      eyebrow: "מדריך טיולי חוף",
      h1: "מדריך לטיול רכב לחוף הים השחור",
      intro: "חוף הים השחור הרומני מציע חופים רחבים, אתרי נופש ואתרים היסטוריים. עם רכב שכור מ-carentals.ro, קל להגיע ולנוע בחופשיות בין ערי החוף השונות.",
      perks,
      sections: [
        {
          h2: "יעדים מרכזיים לאורך החוף",
          body: [
            "קונסטנצה, העיר הגדולה והעתיקה ביותר על החוף, משלבת עיר עתיקה עם חיי לילה תוססים ואתרים רומיים.",
            "מאמאיה, הסמוכה לקונסטנצה, מציעה חופים רחבים ובתי מלון מודרניים, ומהווה יעד קיץ פופולרי במיוחד למשפחות.",
          ],
        },
        {
          h2: "תכנון הנסיעה מבוקרשט",
          body: [
            "המרחק מבוקרשט לחוף הים השחור הוא כשעתיים וחצי עד שלוש שעות נסיעה, מסלול נוח יחסית עם כביש מהיר בחלקו.",
            "בעונת הקיץ מומלץ לצאת לדרך מוקדם בבוקר כדי להימנע מעומסי תנועה, במיוחד בסופי שבוע.",
          ],
        },
        {
          h2: "טיפים לטיול חוף מוצלח",
          body: [
            "רכב שכור מאפשר גמישות לנוע בין אתרי הנופש השונים ולמצוא חופים שקטים יותר מחוץ למרכזי התיירות.",
            "כל השכרה כוללת ביטוח מקיף וקילומטראז' ללא הגבלה, כך שניתן לתכנן גם סיורים נוספים באזור ללא דאגה.",
          ],
        },
      ],
      faqs: [
        { q: "כמה זמן לוקח להגיע לחוף הים השחור מבוקרשט?", a: "בין שעתיים וחצי לשלוש שעות נסיעה, בהתאם לתנועה." },
        { q: "מתי העונה הטובה ביותר לביקור?", a: "החודשים יוני עד ספטמבר הם העונה הפעילה ביותר בחוף." },
        { q: "האם יש חניה נוחה באזורי הנופש?", a: "רוב בתי המלון ואזורי הנופש מציעים חניה, אך מומלץ לבדוק זמינות מראש בעונת השיא." },
        { q: "האם ניתן לשלב את הטיול עם קונסטנצה וגם עם מאמאיה?", a: "בהחלט, שתי הערים סמוכות זו לזו ונגישות בקלות ברכב שכור." },
      ],
      keywords: "טיול חוף הים השחור, מדריך קונסטנצה מאמאיה, השכרת רכב לחוף הים",
    },
    "rules-rovinieta": {
      slug: "kelalei-viniyeta",
      title: "מדריך ויניאטה (אגרת כביש) ברומניה | carentals.ro",
      description: "כל מה שצריך לדעת על הוויניאטה - אגרת הכביש ברומניה. carentals.ro כוללת אותה בכל השכרה, ללא צורך בדאגה.",
      eyebrow: "כללי נהיגה ברומניה",
      h1: "מדריך ויניאטה - אגרת הכביש ברומניה",
      intro: "הוויניאטה היא אגרת כביש חובה לנסיעה בכבישים הבין-עירוניים ברומניה. אצלנו ב-carentals.ro היא כלולה בכל השכרה, כך שאין צורך לדאוג לרכישתה בנפרד.",
      perks,
      sections: [
        {
          h2: "מהי הוויניאטה ולמה היא חובה",
          body: [
            "הוויניאטה היא מדבקה או רישום אלקטרוני המאשר תשלום אגרת שימוש בכבישים הלאומיים ברומניה, ונדרשת לכל רכב הנוסע מחוץ לערים.",
            "נהיגה ללא ויניאטה תקפה עלולה לגרור קנס משמעותי, ולכן חשוב לוודא שהיא בתוקף לאורך כל תקופת ההשכרה.",
          ],
        },
        {
          h2: "איך זה עובד אצלנו",
          body: [
            "בכל השכרה דרך carentals.ro, הוויניאטה כבר כלולה ורשומה על מספר הרכב, כך שאין צורך בפעולה נוספת מצדכם.",
            "אם אתם מתכננים נסיעה ארוכה במיוחד, ודאו מול הצוות שלנו שתוקף הוויניאטה מכסה את כל ימי ההשכרה.",
          ],
        },
        {
          h2: "כבישים הדורשים ויניאטה",
          body: [
            "רוב הכבישים הלאומיים והבין-עירוניים ברומניה דורשים ויניאטה תקפה, בעוד שכבישי עיר ואוטוסטרדות מסוימות עשויים לפעול בשיטת תשלום שונה.",
            "מומלץ להימנע מחריגה מהמסלולים המתוכננים ללא בדיקה, ובמקרה של ספק ניתן לפנות אלינו בוואטסאפ לבירור.",
          ],
        },
      ],
      faqs: [
        { q: "האם הוויניאטה כלולה במחיר ההשכרה?", a: "כן, הוויניאטה כלולה בכל השכרה אצלנו ללא עלות נוספת." },
        { q: "מה קורה אם נוסעים בלי ויניאטה תקפה?", a: "נהיגה ללא ויניאטה תקפה עלולה לגרור קנס, ולכן חשוב לוודא שהיא בתוקף מראש." },
        { q: "האם צריך לחדש את הוויניאטה בעצמי?", a: "לא, אנו דואגים לוויניאטה עבור כל תקופת ההשכרה שהוזמנה." },
        { q: "האם הוויניאטה תקפה בכל רחבי רומניה?", a: "כן, היא תקפה בכל הכבישים הלאומיים והבין-עירוניים ברחבי המדינה." },
      ],
      keywords: "ויניאטה רומניה, אגרת כביש רומניה, כללי נהיגה ברומניה",
    },
    "rules-winter-tires": {
      slug: "kelalei-tzmigei-horef",
      title: "כללי צמיגי חורף ברומניה | carentals.ro", 
      description: "מה חוק הצמיגים בחורף ברומניה ואיך carentals.ro דואגת לרכב מתאים לעונה. מידע חשוב לנהגים בחורף.",
      eyebrow: "כללי נהיגה ברומניה",
      h1: "כללי צמיגי חורף ברומניה",
      intro: "החוק הרומני מחייב שימוש בצמיגי חורף או צמיגים בעלי סימון M+S בתנאי שלג, קרח או טמפרטורות נמוכות. carentals.ro דואגת שכל רכב מצויד בהתאם לעונה ולתנאי הדרך.",
      perks: [
        { title: "רכבים מצוידים לעונה", text: "כל רכב מגיע עם צמיגים המתאימים לתנאי מזג האוויר העונתיים ברומניה." },
        { title: "בדיקה לפני כל השכרה", text: "אנו בודקים את מצב הצמיגים והרכב לפני כל מסירה, לבטיחות מרבית." },
        { title: "ייעוץ למסלולים הרריים", text: "הצוות שלנו ייעץ לכם לגבי מסלולים מומלצים בהתאם לתנאי מזג האוויר." },
        { title: "ביטוח מקיף בכל עונה", text: "ביטוח RCA+CASCO תקף לאורך כל השנה, כולל חודשי החורף." },
      ],
      sections: [
        {
          h2: "מהו חוק הצמיגים ברומניה",
          body: [
            "החוק הרומני מחייב רכבים לנוע עם צמיגי חורף או צמיגי כל עונה עם סימון M+S כאשר הכביש מכוסה שלג, קרח או קרח דק.",
            "אכיפת החוק מתגברת בעיקר בחודשי דצמבר עד פברואר, ובאזורים הרריים כמו הקרפטים בהם מזג האוויר משתנה במהירות.",
          ],
        },
        {
          h2: "איך carentals.ro מתמודדת עם החורף",
          body: [
            "בעונת החורף, כל הרכבים בצי שלנו מצוידים בצמיגים מתאימים לתנאי הדרך, כך שאין צורך לדאוג לכך בעצמכם.",
            "אם אתם מתכננים נסיעה לאזור הררי בחורף, מומלץ לעדכן אותנו מראש כדי שנוכל להתאים את הרכב המתאים ביותר.",
          ],
        },
        {
          h2: "טיפים לנהיגה בחורף ברומניה",
          body: [
            "יש להימנע ממסלולים הרריים כמו הטרנספגרשן בחורף, שכן הכביש נסגר לתנועה בשל שלג כבד ותנאי מזג אוויר קשים.",
            "מומלץ לבדוק תחזית מזג אוויר לפני כל נסיעה ארוכה בחורף, ולשמור על מרחק בטיחה מוגבר בכבישים חלקים.",
          ],
        },
      ],
      faqs: [
        { q: "האם חובה צמיגי חורף בכל רומניה?", a: "החובה חלה כאשר קיימים תנאי שלג, קרח או קרח דק על הכביש, ולא באופן גורף בכל המדינה." },
        { q: "האם הרכב שלכם מצויד לחורף?", a: "כן, בעונת החורף כל רכבי הצי מצוידים בצמיגים המתאימים לתנאי הדרך." },
        { q: "האם הטרנספגרשן פתוח בחורף?", a: "לא, הכביש בדרך כלל סגור לתנועה בין נובמבר למאי בשל שלג כבד." },
        { q: "מה לעשות אם נתקעים בשלג?", a: "צרו קשר עם הצוות שלנו בוואטסאפ ונדאג לסייע בהקדם האפשרי." },
      ],
      keywords: "צמיגי חורף רומניה, כללי נהיגה חורף רומניה, השכרת רכב חורף",
    },
    "rules-speed-cameras": {
      slug: "kelalei-matzlemot-mehirut",
      title: "מצלמות מהירות וכללי תנועה ברומניה | carentals.ro",
      description: "מדריך למצלמות מהירות וכללי תנועה ברומניה - מגבלות מהירות, קנסות ומה חשוב לדעת לפני הנסיעה.",
      eyebrow: "כללי נהיגה ברומניה",
      h1: "מצלמות מהירות וכללי תנועה ברומניה",
      intro: "רומניה מפעילה רשת נרחבת של מצלמות מהירות בכבישים העירוניים והבין-עירוניים. הכירו את מגבלות המהירות והחוקים העיקריים כדי להימנע מקנסות מיותרים במהלך הטיול.",
      perks,
      sections: [
        {
          h2: "מגבלות מהירות ברומניה",
          body: [
            "בעיר המהירות המרבית היא בדרך כלל 50 קמ״ש, בכביש בין-עירוני 90 קמ״ש, ובכביש מהיר 100-130 קמ״ש בהתאם לסוג הכביש.",
            "חשוב לשים לב לשלטי תמרור המציינים מגבלות מהירות משתנות, במיוחד בכניסה ויציאה מיישובים קטנים.",
          ],
        },
        {
          h2: "מצלמות מהירות ואכיפה",
          body: [
            "ברומניה קיימות מצלמות מהירות קבועות ומצלמות ניידות, המופעלות לעיתים ללא התראה מוקדמת בכבישים הראשיים.",
            "קנסות על חריגת מהירות יכולים להיות משמעותיים, ולעיתים מועברים ישירות לחברת ההשכרה ולאחר מכן לשוכר - לכן חשוב לנהוג בזהירות ולשים לב לתמרורים.",
          ],
        },
        {
          h2: "טיפים לנהיגה חוקית ובטוחה",
          body: [
            "מומלץ להשתמש באפליקציית ניווט המתריעה על מצלמות מהירות, ולשמור תמיד על מהירות מותרת בכניסה ליישובים.",
            "יש לזכור כי חגורת בטיחות חובה לכל הנוסעים, ושימוש בטלפון נייד ללא דיבורית אסור בזמן נהיגה.",
          ],
        },
      ],
      faqs: [
        { q: "מה מגבלת המהירות בעיר ברומניה?", a: "בדרך כלל 50 קמ״ש, אלא אם צוין אחרת בתמרור." },
        { q: "מה קורה אם מקבלים דוח מהירות אחרי החזרת הרכב?", a: "הדוח מועבר לחברת ההשכרה ולאחר מכן לשוכר, בהתאם למידע שנמסר לרשויות." },
        { q: "האם יש הרבה מצלמות מהירות ניידות?", a: "כן, בנוסף למצלמות הקבועות קיימות גם מצלמות ניידות המופעלות באופן בלתי צפוי." },
        { q: "האם חגורת בטיחות חובה לכל הנוסעים?", a: "כן, חגורת בטיחות חובה לנהג ולכל הנוסעים ברכב, כולל במושב האחורי." },
      ],
      keywords: "מצלמות מהירות רומניה, כללי תנועה רומניה, מגבלות מהירות רומניה",
    },
    "airport-pickup": {
      slug: "madrih-isuf-shdeh-teufa-otopeni",
      title: "מדריך איסוף רכב בשדה התעופה אוטופני | carentals.ro",
      description: "מדריך שלב-אחר-שלב לאיסוף רכב בנמל התעופה אוטופני עם carentals.ro - מהנחיתה ועד היציאה לדרך.",
      eyebrow: "מדריך צעד אחר צעד",
      h1: "מדריך איסוף רכב בנמל התעופה אוטופני",
      intro: "אספקת רכב בנמל התעופה הנרי קואנדה באוטופני היא תהליך פשוט ומהיר עם carentals.ro. הנה מדריך שלב-אחר-שלב שיעזור לכם לדעת בדיוק למה לצפות מרגע הנחיתה ועד היציאה לדרך.",
      perks: airportPerks,
      sections: [
        {
          h2: "שלב 1: לפני הנחיתה",
          body: [
            "מומלץ לשלוח לנו את פרטי הטיסה - מספר הטיסה, תאריך ושעת נחיתה - דרך וואטסאפ מספר ימים לפני ההגעה, כך שנוכל להתכונן מראש.",
            "אין צורך בכרטיס אשראי או פיקדון מראש - די בהודעה עם הפרטים כדי לאשר את ההזמנה ולתאם את המפגש בנמל התעופה.",
          ],
        },
        {
          h2: "שלב 2: לאחר הנחיתה",
          body: [
            "לאחר איסוף המזוודות, יש לצאת לאזור הגעות ולעדכן אותנו בוואטסאפ כי נחתתם - נציג מטעמנו יגיע לנקודת המפגש שתואמה מראש.",
            "התהליך מהיר וללא צורך בהמתנה בתורים - תוך דקות ספורות תעברו לחתימה על הסכם ההשכרה ותקבלו את מפתחות הרכב.",
          ],
        },
        {
          h2: "שלב 3: יציאה לדרך",
          body: [
            "לפני היציאה, הנציג יעבור אתכם על מצב הרכב, יסביר על הביטוח והוויניאטה, ויוודא שכל שאלה נענתה.",
            "מרגע קבלת המפתחות, תוכלו לצאת מיד לדרככם - בין אם לבוקרשט, לחוף הים השחור או למסלול טרנסילבניה.",
          ],
        },
      ],
      faqs: [
        { q: "מה צריך לשלוח לפני הטיסה?", a: "פרטי הטיסה - מספר טיסה, תאריך ושעת נחיתה - דרך וואטסאפ, מספר ימים מראש." },
        { q: "איפה נפגשים בנמל התעופה?", a: "בנקודת מפגש נוחה באזור ההגעות, שתתואם עמכם מראש." },
        { q: "כמה זמן לוקח תהליך המסירה?", a: "בדרך כלל כעשר עד חמש עשרה דקות בלבד, כולל חתימה על ההסכם." },
        { q: "האם יש עלות נוספת לאיסוף בשדה התעופה?", a: "לא, האיסוף בנמל התעופה אוטופני חינם לחלוטין." },
      ],
      keywords: "איסוף רכב שדה תעופה אוטופני, מדריך השכרת רכב OTP, השכרת רכב נמל תעופה אוטופני",
    },
  },
};
